import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

const ClassTabs = ({ classes, activeClassId, onClassChange }) => {
  const activeClass = classes.find(group => group.object.id === activeClassId)

  return (
    <div className="class-tabs-container">
      <div className="class-tabs-header">
        <h1 className="class-tabs-title">
          {activeClass?.object?.name}
        </h1>
        <div className="class-tabs-info blac">
          {_.size(activeClass?.students)} students
          &nbsp;&nbsp;&nbsp;
          Grade {activeClass?.object?.grade}
        </div>
      </div>

      <div className="class-tabs">
        {_.map(classes, (group) => {
          const isActive = group.object.id === activeClassId

          return (
            <button
              key={group.object.id}
              onClick={() => onClassChange(group.object.id)}
              className={classnames('class-tabs__item', {
                'class-tabs__item--active': isActive
              })}
            >
              {group.object.name}
            </button>
          )
        })}
      </div>
    </div>
  )
}

ClassTabs.propTypes = {
  classes: PropTypes.array.isRequired,
  activeClassId: PropTypes.string,
  onClassChange: PropTypes.func.isRequired
}

export default ClassTabs;
